import { LibraryItem } from '@/components/page-builder/global/library/LibraryItem'
import { Tile } from '@/components/shared/components/Tile/Tile'
import { cn } from '@/lib/styles'
import type { GridCardProps, GridTypeProps } from '@/types/general'
import type { ServerRenderedEntry } from '@/types/helpers'

export const GridEntries = ({
	entries,
	type,
}: {
	readonly entries: ServerRenderedEntry<GridCardProps>[] | null
	readonly type: GridTypeProps
}) => {
	return (
		<div
			className={cn(
				'grid grid-cols-1 sm:grid-cols-2 gap-y-6 lg:gap-y-8 gap-x-7.5 w-full',
				(type === 'library' || type === 'apps') && 'xl:grid-cols-3',
			)}
		>
			{entries?.map((entry, i) => {
				switch (type) {
					case 'library':
						return (
							<LibraryItem
								entryItem={entry}
								key={entry.id}
								loading={i > 5 ? 'lazy' : 'eager'}
								fetchPriority={i > 5 ? 'low' : 'high'}
							/>
						)
					case 'partners':
					case 'apps':
						return <Tile variant="integrations" {...entry} key={entry.id} />
					default:
						return null
				}
			})}
		</div>
	)
}
